module.exports = __webpack_public_path__ + "static/media/AddedLicenseSuccessfullyIcon.7e3cde84.svg";